<template>
  <tela-component title="Formação de Carga">
    <v-card flat rounded="lg">
      <v-card-text
        ><v-data-table
          no-data-text="Nenhuma formação de carga encontrada"
        ></v-data-table
      ></v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
export default {
  components: { TelaComponent },
};
</script>

<style>
</style>